// Zentrale Entscheidung "welches Quell-Label bekommt die Web-Karte".
//
// Die Web-Karten-Seiten (RadarPage, MapPage, PlanningGeozoneMap) blenden
// technische Datenquellen-Hinweise nur für Admins ein. WANN ein leeres Label
// (Pilot) vs. das echte Quell-Label (Admin) durchgereicht wird, lebt hier –
// RN-/Leaflet-frei und damit unter dem tsx-Runner testbar (Regressionsschutz
// für die Verdrahtung, nicht nur für buildEd269PopupHtml selbst).

export type Ed269Country = "at" | "be" | "dk";

export const ED269_SOURCE_LABELS: Record<Ed269Country, string> = {
  at: "Austro Control (ED-269)",
  be: "skeyes / Droneguide (ED-269)",
  dk: "Trafikstyrelsen (Dänemark)",
};

/**
 * Liefert das `sourceLabel` für renderEd269Layer: leerer String für Piloten
 * (kein Quellen-Span im Popup), echtes Quell-Label nur für Admins. Unbekannte
 * Länder ergeben immer einen leeren String.
 */
export function ed269SourceLabelFor(
  iso: string | null | undefined,
  isAdmin: boolean,
): string {
  if (!isAdmin) return "";
  const key = (iso || "").toLowerCase() as Ed269Country;
  return ED269_SOURCE_LABELS[key] ?? "";
}

/**
 * Soll das Radar-Quellen-Status-Panel (ADS-B/OGN-Feeds) gerendert werden?
 * Nur wenn Statusdaten vorliegen UND der Nutzer Admin ist.
 */
export function shouldShowRadarSourcePanel(
  sourceStatus: unknown,
  isAdmin: boolean,
): boolean {
  return Boolean(sourceStatus) && isAdmin;
}
